import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'
import { Constants } from 'common/utils'
import standardiseTitle from 'project/standardiseTitle'
import { planPrice } from 'common/utils/planPrice'
import { PlanSlug } from 'common/planSlugs'

const pageTitle = 'Hoxton Mix'
const defaultStrings = {
  appOGLogo: 'https://www.hoxtonmix.com/images/hm-full-colour.png',
  appOGLogoAlt: `${Constants.companyInformation.name} logo`,
  appSiteName: Constants.companyInformation.name,
  breadcrumbHome: 'Homepage',
  indexDescription: `Virtual office address service with a prime London business address, AI mail handling assistant, free mail scanning, and no hidden fees. From ${planPrice.monthlyOnYearlyPlan(
    PlanSlug.SCAN_LITE,
  )}/month with fast delivery.`,
  virtualOfficeLondonDescription: `Registered office address service with a prime London business address, AI mail handling assistant, free mail scanning, and no hidden fees. From ${planPrice.monthlyOnYearlyPlan(
    PlanSlug.SCAN_LITE,
  )}/month with fast delivery.`,
  indexOGDescription: 'Mail Forwarding & Virtual Office Address Services in London',
  indexTitle: standardiseTitle(
    `Virtual Office Address Services | ${pageTitle}`,
  ),
  organisationName: `Hoxton Mix`,
}
export const seoStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
